var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquiggle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 72,
    viewBox: "0 0 114 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84924 31.9508C8.63333 24.55 15.2026 18.0135 23.4455 12.1124C28.9622 8.16295 48.4468 -7.25369 40.0193 9.60124C35.0282 19.5835 29.9659 29.7143 24.5755 39.4844C20.7114 46.488 18.2309 51.4041 26.71 43.2512C29.4593 40.6076 58.0999 17.804 58.0999 19.7715C58.0999 25.4883 39.5738 51.5565 50.8174 45.2601C53.5983 43.7028 88.0438 24.9892 84.9696 35.9687C82.78 43.7885 81.2873 45.0861 90.1175 41.9956C94.0819 40.608 115.349 30.4949 112.09 41.4933C109.097 51.5947 104.446 61.3497 99.0322 70.372",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquiggle);
export default __webpack_public_path__ + "static/media/squiggle.ccd20b92c8e459e135f484aad1b5ba13.svg";
export { ForwardRef as ReactComponent };